import { useMutation, useQueryClient } from "react-query";
import axios from '../axios';

const useRequestBags = ({onSuccess, onError}) => {
  const queryClient = useQueryClient();
  const mutation = useMutation(
    async (params) => {
      return await axios.post("/api/bag-requests/seller", {
        number_of_items_requested: params?.number_of_items_requested,
        seller_id: params?.seller_id,
        number_of_bags: params?.number_of_bags,
        charityId: params?.charityId,
        returned: params?.returned,
      }); 
    },
    {
      onSuccess: (res) => {
        queryClient.invalidateQueries("bags");
        onSuccess(res);
      },
      onError: (err) => onError(err)
    }
  )

  return mutation;
}

export default useRequestBags;